import React from 'react';
import {
    WORKOUT_REPS_MODE_OPTIONS,
    isNormalRepsExercise,
    normalizeWorkoutRepsMode,
} from '../../../constants/workoutRepsMode';
import { EditorField, editorControlClass, editorNumClass } from './ExerciseEditorParts';

const modeClass = `h-9 w-32 shrink-0 px-2 ${editorControlClass}`;

/**
 * WEBAPP-15: input ripetizioni (fisso / range / a cedimento) - solo esercizi normali.
 * Layout compatto in riga, come nei template.
 */
export default function WorkoutRepsInputs({ exercise, onUpdate }) {
    const isCardio = exercise.is_cardio === 1;
    const isIsometricScheda = exercise.is_isometric_scheda === 1;

    const numberInput = (field, fallback, props = {}) => (
        <input
            type="number"
            min="1"
            value={exercise[field] ?? ''}
            onChange={(e) => {
                const value = e.target.value;
                onUpdate(exercise.id, field, value === '' ? '' : parseInt(value, 10) || '');
            }}
            onBlur={fallback == null ? undefined : (e) => {
                if (e.target.value === '' || e.target.value === '0') {
                    onUpdate(exercise.id, field, fallback);
                }
            }}
            onFocus={(e) => e.target.select()}
            className={editorNumClass}
            {...props}
        />
    );

    if (isCardio) {
        return <EditorField label="Minuti">{numberInput('ripetizioni', 20, { placeholder: '30' })}</EditorField>;
    }

    if (isIsometricScheda) {
        return <EditorField label="Secondi">{numberInput('ripetizioni', 60, { placeholder: '60' })}</EditorField>;
    }

    const repsMode = normalizeWorkoutRepsMode(exercise.reps_mode);

    const handleModeChange = (mode) => {
        onUpdate(exercise.id, 'reps_mode', mode);
        if (mode === 'fixed') {
            onUpdate(exercise.id, 'ripetizioni_min', null);
            onUpdate(exercise.id, 'ripetizioni_max', null);
            if (!exercise.ripetizioni) {
                onUpdate(exercise.id, 'ripetizioni', 12);
            }
        } else if (mode === 'range') {
            onUpdate(exercise.id, 'ripetizioni_min', exercise.ripetizioni_min ?? 8);
            onUpdate(exercise.id, 'ripetizioni_max', exercise.ripetizioni_max ?? 12);
        } else if (mode === 'amrap') {
            onUpdate(exercise.id, 'ripetizioni_min', null);
            onUpdate(exercise.id, 'ripetizioni_max', null);
            onUpdate(exercise.id, 'ripetizioni', 0);
        }
    };

    return (
        <EditorField label="Ripetizioni">
            <div className="flex flex-wrap items-center gap-2">
                <select
                    value={repsMode}
                    onChange={(e) => handleModeChange(e.target.value)}
                    className={modeClass}
                    aria-label="Modalità ripetizioni"
                >
                    {WORKOUT_REPS_MODE_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </select>

                {repsMode === 'fixed' && numberInput('ripetizioni', 12, { placeholder: '12', 'aria-label': 'Ripetizioni' })}

                {repsMode === 'range' && (
                    <>
                        {numberInput('ripetizioni_min', null, { placeholder: '8', 'aria-label': 'Ripetizioni minime' })}
                        <span className="text-xs text-gray-400" aria-hidden>–</span>
                        {numberInput('ripetizioni_max', null, { placeholder: '12', 'aria-label': 'Ripetizioni massime' })}
                    </>
                )}

                {repsMode === 'amrap' && (
                    <span className="text-xs italic text-gray-500 dark:text-white/60">A cedimento, nessun numero fisso</span>
                )}
            </div>
        </EditorField>
    );
}

export { isNormalRepsExercise };
